import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ProductState } from './biz-product.reducer';
import { AppState } from '../app.state';

// Feature selector for the ProductState
export const selectProductState = createFeatureSelector<AppState, ProductState>('bizProducts');



// Selector for biz products
export const selectBizProducts = createSelector(
  selectProductState,
  (state: ProductState) => state.bizProducts
);

// Selector for loading state
export const selectBizProductsLoading = createSelector(
  selectProductState,
  (state: ProductState) => state.loading
);

// Selector for error state
export const selectBizError = createSelector(
  selectProductState,
  (state: ProductState) => state.error
);
